import styled from 'styled-components';

export const Wrapper = styled.div`
  position: relative;
`;

export const Amount = styled.span`
  font-weight: bold;
  font-size: 16px;
`;
